/*loginModalElm.on('hidden.bs.modal', function () {
		if (!user) freeCounselling();
});*/

$(window).scroll(function () {
	const urlParams = new URLSearchParams(window.location.search);
	let previewURL = urlParams.get('preview');
	if(DEBUG) console.log("previewURL??",previewURL);
		if (!user) {
				if (location.search.includes('version') || previewURL) {
						hideBlurContent();
						withoutBlurLoginDesign($(window).scrollTop());
						$('#blurModal').hide();
				} else {

					$('.blurEffectSchool>div>div>*').css({
							'filter': 'blur(.825rem)',
							'pointer-events': 'none',
							'cursor': 'no-drop',
							'user-select': 'none'
						}).prop('disabled', true);

						blurPreviewDesign($(window).scrollTop(), $('#AssistantJsLoaded').val());
				}
		}
});
$(document).scrollTop($(document).scrollTop() - 1);

/*	NEW ASSISTANT CODE START
  Assistant Open ON SCROLL	*/

$(window).scroll(function () {
		const scroll = $(window).scrollTop();
		const AssistantJsLoaded = $('#AssistantJsLoaded').val();
		if (location.search.includes('version')) {
				hideBlurContent();
				withoutBlurLoginDesign(scroll);
		} else blurPreviewDesign(scroll, AssistantJsLoaded);
});

/*assistantModalElm.on('hidden.bs.modal', function () {
		localStorage.setItem('assistant', 'fclosed');
		if (!user) {
				$('.button_1O').show();
				// if (!location.search.includes('preview')) loginModalElm.modal('show', {backdrop: 'static', keyboard: false});
		} else freeCounselling();
});*/

/*NEW ASSITANT CODE END */

$.fn.isOnScreen = function () {

		const win = $(window);
		const viewport = {top: win.scrollTop(), left: win.scrollLeft()};
		viewport.right = viewport.left + win.width();
		viewport.bottom = viewport.top + win.height();

		const bounds = this.offset();
		if (typeof bounds === "undefined") return;
		bounds.right = bounds.left + this.outerWidth();
		bounds.bottom = bounds.top + this.outerHeight();
		return (!(viewport.right < bounds.left || viewport.left > bounds.right || viewport.bottom < bounds.top || viewport.top > bounds.bottom));
};

function blurDesignModal(scroll) {
		if ($('#BlurEffect').isOnScreen() === true) {
				if ($('.footer').isOnScreen() === true) $('#blurModal').hide();
				else {
						if (scroll < 600) $('#blurModal').hide(); else $('#blurModal').show();
				}
		} else {
				if ($('.footer').isOnScreen() === true) $('#blurModal').hide(); else $('#blurModal').hide();
		}
}

function blurPreviewDesign(scroll, AssistantJsLoaded) {
	const urlParams = new URLSearchParams(window.location.search);
	let previewURL = urlParams.get('preview');
		if (!user) {
			if(!previewURL){
				OpenAssistant(AssistantJsLoaded);
				blurDesignModal(scroll);
				$('#BlurEffect').removeClass('no-blur');
			}
		} else {
				hideBlurContent();
				$('#blurModal').hide();
		}
}

function OpenAssistant(assistantJsLoaded) {
		let assistType = localStorage.getItem('assistant');
		if (assistType !== 'fclosed') {
				if (assistantJsLoaded === 1) {
						assistantModalElm.modal('show', {backdrop: 'static', keyboard: false});
						setTimeout(() => $('.button_1O').hide(), 5000);
				}
		}
}

function openLoginPopup() {
		loginModalElm.modal('show');
}

function hideBlurContent() {
		$('#BlurEffect').addClass('no-blur');
}

function withoutBlurLoginDesign(scroll, assistantJsLoaded = 0) {
		if (scroll > 790) {
				if (!user && !location.search.includes('preview')) {
						let assistType = localStorage.getItem('assistant');
						if (assistType !== 'fclosed') {
								if (assistantJsLoaded === 1) {
										assistantModalElm.modal('show', {backdrop: 'static', keyboard: false});
										setTimeout(() => $('.button_1O').hide(), 5000);
								}
						}
				}
		}
}


// if vad school then set vad PROCESSING STATE IN school side and send notification to school
function sendVadNotificationProcessing() {
		if (schoolType !== 2 && user) {
				$.ajax({
						type: 'POST',
						url: `${HOST}/schools/Residential/server/detail-page-send-vad-notification.php`,
					data: {"school_id": schoolId, "school_type": schoolType === 4 ? 3 : schoolType},
						success: function (data) {
								if (DEBUG) console.log('sendVadNotificationProcessing');
						}, error: function (data) {
								if (DEBUG) console.log(data);
						}
				});
		}
}

$(document).ready(function () {
		sendVadNotificationProcessing();
});
